module.exports = {"610728001":"泾洋街道","610728101":"渔渡镇","610728102":"盐场镇","610728103":"观音镇","610728104":"巴庙镇","610728105":"兴隆镇","610728106":"长岭镇","610728107":"三元镇","610728108":"简池镇","610728109":"碾子镇","610728110":"小洋镇","610728111":"青水镇","610728112":"赤南镇","610728113":"平安镇","610728114":"杨家河镇","610728115":"巴山镇","610728116":"黎坝镇","610728117":"仁村镇","610728118":"大池镇","610728120":"永乐镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610728.json
// module id = 2994
// module chunks = 0